// import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw, EditorState } from 'draft-js';

const loadPage = (raw) => {
  if (!raw) return (EditorState.createEmpty());
  const thawed = JSON.parse(raw);
  const cooked = convertFromRaw(thawed);
  const editor = EditorState.createWithContent(cooked);
  return (editor);
};

export default loadPage;

/*
STORING IN CASE WE HAVE TO GO BACK TO THIS:
let burnt;

const options = {
  blockRenderers: {
    atomic: (block) => {
      const entity = burnt.getEntity(block.getEntityAt(0));
      if (!entity) return null;
      const { type } = entity;
      console.log(entity.props);
      if (type === 'VID') {
        const { src } = entity.getData();
        return (
          `<video controls style="position: relative">
            <source src="${src}" type="video/mp4" />
          </video>`
        );
      }
      if (type === 'IMAGE') {
        const { src } = entity.getData();
        return (
          `<image src="${src}" />`
        );
      }
      return (<div />);
    },
  },
};

const loadPageAsHTML = (raw) => {
  if (!raw) return (EditorState.createEmpty());
  console.log(raw);
  const thawed = JSON.parse(raw);
  const cooked = convertFromRaw(thawed);
  const editor = EditorState.createWithContent(cooked);
  burnt = editor.getCurrentContent();
  const html = stateToHTML(burnt, options);
  return html;
};
*/
